import {
  Alert,
  Anchor,
  Code,
  Container,
  List,
  ListItem,
  Stack,
  Text,
  Title,
} from "@mantine/core";

export default function PartnerPlaybook() {
  return (
    <Container size="xl">
      <Stack gap="lg">
        <div>
          <Title order={1}>Playbook</Title>
          <Text c="dimmed" mt={4}>
            For B&Q onboarding and key-account people. One level deeper than
            the merchant happy path.
          </Text>
        </div>

        <div>
          <Title order={3}>What to say</Title>
          <Text mt="xs">
            Once you are approved, the next step is getting a complete
            catalogue live. Optivise is an optional tool that turns Amazon
            listings or spreadsheets into B&Q Marketplace–ready files. You
            review the output and upload it yourself. You remain responsible
            for your listings.
          </Text>
        </div>

        <Alert color="yellow" title="Do not say">
          <List size="sm" spacing={4}>
            <ListItem>“B&Q-approved copy” or “our AI wrote this.”</ListItem>
            <ListItem>That Optivise will log into B&Q or publish for them.</ListItem>
            <ListItem>A trial SKU count you have not assigned from the pool.</ListItem>
            <ListItem>A price below 50p per SKU.</ListItem>
          </List>
        </Alert>

        <div>
          <Title order={3}>Price</Title>
          <List mt="xs" size="sm">
            <ListItem>50p per SKU ($0.70). No subscription.</ListItem>
            <ListItem>
              100 extra SKUs free on the merchant’s first paid purchase — only
              after Stripe takes payment. Never on signup.
            </ListItem>
            <ListItem>
              A merchant with 90 SKUs still buys 100 (£50). They get 100 extra
              after that payment.
            </ListItem>
            <ListItem>
              Trial SKUs come from your pool. You choose how many per merchant.
            </ListItem>
            <ListItem>
              Trial credits spend only on B&Q Marketplace listings.
            </ListItem>
          </List>
        </div>

        <div>
          <Title order={3}>Signup codes</Title>
          <Text size="sm" mt="xs">
            Create a code, set the SKU grant, send the merchant{" "}
            <Code>https://app.optivise.io/auth/register?code=THECODE</Code>.
            They create their own account. The grant comes out of your pool.
          </Text>
        </div>

        <div>
          <Title order={3}>Look up a merchant</Title>
          <Text size="sm" mt="xs">
            Open Merchants. You will see grant remaining (left / granted),
            whether they have bought SKUs, SKUs processed, and last activity.
            Assign more SKUs from the pool if they stall with an empty grant.
          </Text>
        </div>

        <div>
          <Title order={3}>If a merchant is stuck</Title>
          <List mt="xs" size="sm">
            <ListItem>Confirm they used the code (they appear under Merchants).</ListItem>
            <ListItem>
              Upload: CSV or XLSX from a webshop, eBay, a supplier, or Amazon
              ASINs (use the ASIN template).
            </ListItem>
            <ListItem>
              If Optivise is disabled, the page says why — file still checking,
              Amazon lookup not confirmed, or headers look like codes.
            </ListItem>
            <ListItem>
              They download the file and upload it in their own B&Q back
              office. Do not do that upload for them.
            </ListItem>
            <ListItem>
              Escalate to{" "}
              <Anchor href="mailto:support@optivise.io" size="sm">
                support@optivise.io
              </Anchor>
              {" "}or WhatsApp Christoph. Light support. No white-glove.
            </ListItem>
          </List>
        </div>

        <div>
          <Title order={3}>Contact</Title>
          <List mt="xs" size="sm">
            <ListItem>
              Email:{" "}
              <Anchor href="mailto:support@optivise.io">
                support@optivise.io
              </Anchor>
            </ListItem>
            <ListItem>
              WhatsApp / calls: Christoph Menge,{" "}
              <Anchor href="https://wa.me/4915112763109">
                +49 151 12763109
              </Anchor>
            </ListItem>
          </List>
        </div>
      </Stack>
    </Container>
  );
}
